import React, {Component} from 'react';
 
import {Accordion} from 'react-bootstrap';

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic3.jpg";
 

class ServiceT extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Tratamiento Médico</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Tratamiento Médico</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">Recupere su salud</h2>
											<p className="mb-0">Las enfermedades gastrointestinales tienen una alta prevalencia en la vida cotidiana, sin embargo, no son normales, y no es bueno acostumbrarse a vivir con ellas <br></br> Por medio de un diagnóstico oportuno y un Tratamiento Médico, es posible recuperar su salud en conjunto con buenos hábitos de alimentación <br></br> En Gastrocirugia Aguascalientes ofrecemos servicios de calidad que ayudan en gran medida a garantizar que se cumplan sus requisitos. Contamos con profesionales capacitados y que tienen los conocimientos técnicos necesarios sobre el tema. Nuestro servicio al paciente se centra en encontrar soluciones a sus problemas, y nuestras reseñas demuestran que puede confiar en nosotros. No dude en ponerse en contacto en cualquier momento para analizarlo más a fondo.</p>
										</div>
										 
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Preguntas Frecuentes</h4>
										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>Quien es el Dr. Eduardo Alvarez del Castillo Sanchez?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0"> El Dr. Eduardo Alvarez del Castillo es un Gastroenterólogo Especializado en Videocirugía Laparoscópica y cirugía general. Con más de 25 años de experiencia</p>
												</Accordion.Body>
											</Accordion.Item>
											 
											<Accordion.Item eventKey="5">
												<Accordion.Header>Cómo puedo contactar con ustedes?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Puede contactarnos al Tel.  (+52) 449 266 9487 o puede crear una cita en Doctoralia, en donde la podrá agendar el día y hora que se ajuste a sus tiempos. De click en 'Agendar Cita' para ser redirigido al sitio.</p>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</div>
								</div>
								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
										<div className="widget">
											<ul className="service-menu">
											<a target="_blank" rel="noreferrer"  href="https://www.doctoralia.com.mx/eduardo-alvarez-del-castillo-sanchez/cirujano-general/aguascalientes" className="btn btn-primary shadow">Agendar Cita<i className="btn-icon-bx fas fa-chevron-right"></i></a>
											</ul>
										</div>
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceT;
